"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageUrl = void 0;

var _hubspot = require("hubspot.bender");

var getImageUrl = function getImageUrl(name) {
  var extension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.svg';
  var isIE11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return _hubspot.staticDomainPrefix + "/ui-images/static-2.343/optimized/" + name + (isIE11 ? '-ie11' : '') + extension;
};

exports.getImageUrl = getImageUrl;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-images/static-2.343/js/index.js
// module id = 766
// module chunks = 209 210 211 212